<template>
    <v-card class="elevation-12">
        <v-toolbar color="primary" dark dense>
            <v-toolbar-title> Connectez-vous </v-toolbar-title>
        </v-toolbar>

        <v-card-text class="pt-4">

            <p v-if="isSessionExpired">
                Votre session à expirée, vous pouvez choisir de rester sur cette page ou vous pouvez vous reconnecter.
            </p>

            <ValidationObserver ref="observer">
                <ValidationProvider v-slot="{ errors }" name="Client" rules="required">
                    <v-autocomplete v-show="$store.state.application.localEnv" v-model="providerCode" :items="providers" placeholder="Client" prepend-icon="fas fa-users" menu-props="offsetY" :error-messages="errors" outlined dense />
                </ValidationProvider>

                <ValidationProvider v-slot="{ errors }" name="Compte" rules="required">
                    <v-text-field v-model="account" placeholder="Compte" prepend-icon="fas fa-user" @keydown.enter="submit" :error-messages="errors" outlined dense />
                </ValidationProvider>

                <ValidationProvider v-slot="{ errors }" name="Mot de passe" rules="required">
                    <v-text-field v-model="password" placeholder="Mot de passe" @keydown.enter="submit" prepend-icon="fas fa-key" :type="showPassword ? 'text' : 'password'" @click:append="showPassword = !showPassword" :append-icon="showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'" :error-messages="errors" outlined dense />
                </ValidationProvider>
            </ValidationObserver>
        </v-card-text>

        <v-card-actions>
            <v-btn v-if="isSessionExpired" @click="$emit('close')" small> Rester </v-btn>

            <v-spacer />

            <v-btn @click="submit" color="primary" small> Connexion </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: 'LoginForm',

    props: {
        isSessionExpired: { type: Boolean, default: false }
    },

    components: {
    },

    data: () => ({
        account: '',
        password: '',

        showPassword: false,

        providers: []
    }),

    methods: {
        async submit() {
            try {
                const valid = await this.$refs.observer.validate();
                if (!valid) {
                    return;
                }

                this.setLoading(true);
                const body = {
                    type: 'user',
                    login: this.account,
                    password: this.password,
                    providerCode: this.providerCode
                };
                const { success, err } = await this.repos.auth.login(body);
                if (success) {
                    this.$notify({
                        title: 'Bienvenue',
                        text: 'Bienvenue sur l\'espace partenaire',
                        type: 'success'
                    });

                    if (this.isSessionExpired) {
                        this.$emit('close');
                    } else {
                        if (this.$route.query.redirect) {
                            this.$router.push({ path: this.$route.query.redirect, hash: this.$route.query.hash });
                        } else {
                            if (this.getConfig('messages.enabled', true)) {
                                this.$router.push('/messages');
                            } else {
                                this.$router.push('/actualites');
                            }
                        }
                    }
                } else {
                    throw new Error(err);
                }
            } catch (err) {
                console.error(err);
                this.$notify({
                    title: 'Erreur',
                    text: err.message,
                    type: 'error'
                });
            } finally {
                this.setLoading(false);
            }
        },

        async fetchProviders() {
            try {
                const { providers } = await this.repos.providers.getAvailables();
                this.providers = providers;
            } catch (err) {
                console.error(err);
            }
        }
    },

    computed: {
        providerCode: {
            get() {
                return this.$store.state.application.providerCode;
            },

            set(providerCode) {
                this.$store.commit('application/setProviderCode', providerCode);
            }
        }
    },

    created() {
        if (this.$store.state.application.localEnv) {
            this.fetchProviders();
        }
    }
};
</script>